import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// project import
import { APP_DEFAULT_PATH } from '../../config';
import useAuth from '../../hooks/useAuth';

// ==============================|| GUEST GUARD ||============================== //

const GuestGuard = ({ children }) => {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  // location não está sendo usado, pode até remover se quiser

  useEffect(() => {
    if (isLoggedIn) {
      // ✅ Agora sim: se já está logado, vai pro sistema, não pro login!
      navigate(APP_DEFAULT_PATH, { replace: true }); 
    }
  }, [isLoggedIn, navigate]); 

  return children;
};

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default GuestGuard;